'use strict';

(function (angular, $) {
    var $personalAppointmentForm = $('#jwsdw-store-personalAppointment'),
        $successMessage = $personalAppointmentForm.find('.jws-formSuccessMessage'),
        $generalErrorMessage = $personalAppointmentForm.find('.jwsdw-formErrorMessage-general'),
        $invalidFieldsErrorMessage = $personalAppointmentForm.find('.jwsdw-formErrorMessage-invalidFields'),
        $button = $personalAppointmentForm.find('.jws-buttonYellow'),
        $buttonText = $personalAppointmentForm.find('.jwsdw-buttonText'),
        $spinner = $personalAppointmentForm.find('.jwsdw-spinner'),
        minDate = new Date(),
        appointmentLength = 1,
        xhr;

    // initialize product detail angular app
    // bootstrap app manually as only the first app on a page can be initialized by data-ng-app (which is the framework/header)
    angular.bootstrap(document.getElementById('jwsdw-store-details'), ['jwsdw.storeDetail']);

    $.datepicker.setDefaults($.datepicker.regional[window.jwsdwSettings.languageCode]);
    $('#jwsdw-store-personalAppointment-date').datepicker({
        'showOtherMonths': true,
        'minDate': minDate,
        'dateFormat': 'dd.mm.yy',
        'beforeShowDay': setUnavailable,
        'onSelect': updatePreferredTimeSelect
    });

    if ($('.jwsdw-storeDetail-header').hasClass('swiper-container')) {
        window.jwsdwApi.slider.initSwiper(
            '.jwsdw-storeDetail-header',
            {
                'init': false,
                'loop': true,
                'autoplay': {
                    'delay': 5000,
                    'disableOnInteraction': true
                },
                'speed': 1250,
                'effect': 'fade',
                'fadeEffect': {
                    'crossFade': true
                },
                'preloadImages': false,
                'slidesPerView': 1
            }
        );
    }

    /**
     * @description Method to remove times that the store will not be open at
     * @param {String} dateStr date represented as string
     * @returns {void}
     */
    function updatePreferredTimeSelect(dateStr) {
        var dateParts = dateStr.split('.'),
            year = dateParts[2],
            month = dateParts[1],
            day = dateParts[0],
            date = new Date(year + '-' + month + '-' + day),
            now = new Date(),
            minTime = window.jwsdwStoreSettings.storeHours[date.getDay()][0].fromHour,
            maxTime = window.jwsdwStoreSettings.storeHours[date.getDay()][0].toHour;
        $('#jwsdw-store-personalAppointment-time option').each(function() {
            var currentHour = parseInt($(this).attr('value').split(':')[0]);
            date.setHours(currentHour);
            if (currentHour < minTime || currentHour > (maxTime - appointmentLength) ||
                date.getTime() < now.getTime()) {
                $(this).addClass('jws-hidden');
                $(this).prop('disabled', true);
            } else {
                $(this).removeClass('jws-hidden');
                $(this).prop('disabled', false);
            }
        });
        if ($('#jwsdw-store-personalAppointment-time option:selected').prop('disabled')) {
            $('#jwsdw-store-personalAppointment-time option:not(:selected,:disabled)').eq(0).prop('selected', true);
        }
    }

    /**
     * @description Method to check if date is available
     * @param {Date} date date to check
     * @returns {Array} array of availability data
     */
    function setUnavailable(date) {
        var storeHours = window.jwsdwStoreSettings.storeHours[date.getDay()],
            minDateStoreHours = window.jwsdwStoreSettings.storeHours[minDate.getDay()];
        if (storeHours &&
            (date.toLocaleDateString() !== minDate.toLocaleDateString() || minDateStoreHours[minDateStoreHours.length - 1].toHour > minDate.getHours())) {
            return [true, ''];
        }
        return [false, '', 'Unavailable'];
    }

    /**
     * @description Method to handle form submits
     * @param {Object} event the event that triggered the handler
     * @param {Function} successCallback the callback that is triggered when the ajax call was successful
     * @param {Function} errorCallback the callback that is triggered when the ajax call was unsuccessful
     * @param {Function} beforeSendCallback the callback that is triggered before the ajax form is sent
     * @param {Function} completeCallback the callback that is triggered after the ajax form is completed
     * @param {Object} [fieldsToSend] optional fields that will be sent instead of the full form
     * @returns {void}
     */
    function formSubmit (event, successCallback, errorCallback, beforeSendCallback, completeCallback, fieldsToSend) {
        var $this = $(this),
            $captcha = $this.find('.g-recaptcha');

        event.preventDefault();

        // only submit form if frontend validation is successful and no other call is executed
        if (!$this.valid() || (xhr && xhr.readyState !== 4)) {
            return;
        }

        if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
            if (!window.grecaptcha || window.jwsdwUtil.captcha.getResponse($captcha.attr('id')).length !== 0) {
                return;
            }
            window.jwsdwUtil.captcha.execute($captcha.attr('id')).then(submitFormHandler);
        } else {
            submitFormHandler();
        }

        /**
         * @function
         * @description Handler to trigger submit again when form is valid
         * @return {void}
         */
        function submitFormHandler() {
            if (window.jwsdwRecaptchaSettings.captchaDisabled === false && window.jwsdwUtil.captcha.getResponse($captcha.attr('id')).length === 0) {
                // no response yet, check again in 200ms
                setTimeout(submitFormHandler, 200);
                return;
            }

            window.jwsdwApi.tracking.fireEvent('personalShopping', {
                'type': 'personalShopping'
            });

            // XHR request to form action url with form fields as parameters
            $.ajax($this.attr('action'), {
                'data': !fieldsToSend ? $this.serialize() : fieldsToSend.serialize(),
                'beforeSend': beforeSendCallback,
                'error': errorCallback,
                'success': successCallback,
                'complete': completeCallback,
                'method': $this.attr('method') || 'GET'
            });
        }
    }

    /**
     * @description Method to invalidate given fields
     * @param {Object} $form form to invalidate
     * @param {Array} errorFields array of field names to invalidate
     * @returns {void} nothing
     */
    function invalidateFields($form, errorFields) {
        var validator = $form.validate(),
            errorFieldsObj = {};

        errorFields.forEach(function(field) {
            errorFieldsObj[field] = '';
        });
        validator.showErrors(errorFieldsObj);
        $invalidFieldsErrorMessage.removeClass('jws-hidden');
    }

    /**
     * Method to execute the before send logic before the ajax call is made
     * @returns {void}
     */
    function personalAppointmentBeforeSendCallback () {
        $generalErrorMessage.addClass('jws-hidden');
        $invalidFieldsErrorMessage.addClass('jws-hidden');
        $successMessage.addClass('jws-hidden');
        $button.attr('disabled', 'disabled');
        $buttonText.addClass('jwsdw-invisible');
        $spinner.removeClass('jws-hidden');
    }

    /**
     * Method to execute the complete logic after the ajax call is made
     * @returns {void}
     */
    function personalAppointmentCompleteCallback () {
        var $captcha = $personalAppointmentForm.find('.g-recaptcha');

        $button.removeAttr('disabled');
        $buttonText.removeClass('jwsdw-invisible');
        $spinner.addClass('jws-hidden');

        if (window.jwsdwRecaptchaSettings.captchaDisabled === false) {
            window.grecaptcha.reset(window.jwsdwRecaptcha[$captcha.attr('id')]);
        }

        window.jwsdwMediator.publish('updateVerticalScroll');
    }

    /**
     * Method to execute if address was handled successfully
     * @param {object} data the response data
     * @returns {object} response data
     */
    function personalAppointmentSuccessCallback (data) {
        $button.addClass('jws-hidden');
        $successMessage.removeClass('jws-hidden');
        return data;
    }

    /**
     * Method to execute if address was not handled successfully
     * @param {object} data the response data
     * @returns {void}
     */
    function personalAppointmentErrorCallback (data) {
        if (data.responseJSON && data.responseJSON.details && data.responseJSON.details.errorFields) {
            invalidateFields($personalAppointmentForm, data.responseJSON.details.errorFields);
        } else {
            $generalErrorMessage.removeClass('jws-hidden');
        }
    }

    $personalAppointmentForm.submit(function (event) {
        formSubmit.call(
            this,
            event,
            personalAppointmentSuccessCallback,
            personalAppointmentErrorCallback,
            personalAppointmentBeforeSendCallback,
            personalAppointmentCompleteCallback
        );
    });
}(angular, jQuery));
